<template>
  <div class="hello">
    <div class="case">
      <!-- 头部 -->
      <div class="top">
        <div class="ti-blck"></div>
        <div class="title">Registered to attend Digital City World Congress 2023</div>
        <p class="introduce">
          Thank you for your interest in DC World Congress and we look forward to seeing you in October. Please fill in this form. If you have any questions regarding the registration process, please do not hesitate to contact us at
          <a href="mailto:crn.zhang@cps.com.cn">crn.zhang@cps.com.cn</a> /
          <a href="mailto:crn.service@cps.com.cn">service@cps.com.cn</a>
        </p>
        <p class="must">*Required</p>
      </div>
      <!-- 尾部 -->
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="0px"
        class="demo-ruleForm"
      >

        <div class="tail">
          <el-form-item prop="name">
            <label>
              Full Name（same as passport/ Ms./Mr.)
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.name" type="text" placeholder="Your answer"></el-input>
          </el-form-item>
        </div>

        <div class="tail">
          <el-form-item prop="Company">
            <label>
              Company
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.Company" placeholder="Your answer"></el-input>
          </el-form-item>
        </div>

        <div class="tail">
          <el-form-item prop="Nationality">
            <label>
              Company/Organization
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.Nationality" placeholder="Your answer"></el-input>
          </el-form-item>
        </div>

       <div class="tail">
         <el-form-item prop="position">
           <label>
             Position
             <span class="sign">*</span>
           </label>
           <el-input v-model="ruleForm.position" placeholder="Your answer"></el-input>
         </el-form-item>
       </div>

       <div class="tail">
         <el-form-item prop="email">
           <label>
             Contact Email
             <span class="sign">*</span>
           </label>
           <el-input v-model="ruleForm.email" placeholder="Your answer"></el-input>
         </el-form-item>
       </div>

       <div class="tail">
         <el-form-item prop="phone_number">
           <label>
             Contact Number
             <span class="sign">*</span>
           </label>
           <el-input v-model="ruleForm.phone_number" placeholder="Your answer"></el-input>
         </el-form-item>
       </div>


        <div class="tail">
          <el-form-item prop="address">
            <label>
              Contact IM (Wechat/Whatsapp /Others)
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.address" placeholder="Your answer"></el-input>
          </el-form-item>
        </div>

        <div class="tail">
          <!-- prop="Company" -->
          <el-form-item >
            <label>
              Company Introduction (approx. 300 words)
              <span class="sign"></span>
            </label>
            <el-input v-model="ruleForm.introduction" placeholder="Your answer"></el-input>
          </el-form-item>
        </div>

        <div class="tail">
          <el-form-item prop="potential">
            <label>
              Passport Number / ID Number
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.potential" placeholder="Your answer"></el-input>
          </el-form-item>
        </div>

        <div class="tail">
          <!-- prop="c_logo" -->
          <el-form-item  class="inpdisp">
            <label>
              Passport /ID Photo
               <span class="sign">*</span>
            </label>
            <el-upload
              class="upload-demo"
              action="https://en.droneworldcongress.com/form/index/uploads/index.html"
              :on-change="handleChange"
              :on-success="logo_success"
              accept=".jpg, .jpeg, .png"
              :before-upload="logo_before"
            >
              <el-button size="small" type="primary">Click on the upload</el-button>
              <div slot="tip" class="el-upload__tip">Only JPG/PNG files can be uploaded，</div>
            </el-upload>
            <el-input v-model="ruleForm.c_logo" placeholder="您的回答"></el-input>
          </el-form-item>
        </div>


<!--         <div class="tail">
                            <el-form-item label="Passport /ID Photo" prop="c_logo">


                                <el-upload
                                        class="avatar-uploader"
                                        action="https://en.droneworldcongress.com/form/index/uploads/index.html"
                                        :before-upload="beforeAvatarUpload"
                                        :on-success="imgUploadSuccess"
                                        :before-remove="removeUpload"
                                        :headers="uploadHeaders"
                                        >

                                    <el-button size="small" ><i class="el-icon-upload2"></i>&nbsp;&nbsp;<span class="uploadText">Upload Files</span></el-button>

                                </el-upload><br>
                                <div style="color:#999"  class="logo">Only JPG/PNG files can be uploaded，</div>
                                <br>

                                < img style="width: 200px" v-show="ruleForm.c_logo != ''" :src="ruleForm.c_logo" class="avatar">
</div> -->

<!--        <div class="tail">
          <el-form-item prop="position">
            <label>
              Name of Company Representative (and title)
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.position" placeholder="Your answer"></el-input>
          </el-form-item>
        </div> -->



        <div class="tail">
          <div class="cause">Parallel Forums Selection (If applicable). Please note that there will be changes to the forums.</div>
         <p class="tick2021">Please tick the forum that you are interested in.</p>
          <el-form-item prop="forum">

     <el-checkbox-group v-model="ruleForm.forum">
            <el-checkbox label="The 2nd Intelligent Police and Equipment Innovation and Application Forum" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="Biometrics Application Forum" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="The 17th China Security Forum-Management Forum" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="AI Empowered City Brains" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="Digital Government Development Forum" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="Intelligent Security Drone and Counter-UAS Technology Application Forum" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="The 9th China Intelligent Parking Industry Development Summit" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="360 Smart Life" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="The 17th China Security Forum-Technology Forum" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="Global Mayors' Roundtable" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="Digital City and Industrial Cluster Forum" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="Digital City Low Altitude Economy Industrial Park Development Forum" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="The 20th China (International) Urban Intelligent Transportation Forum" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="Committee for Promoting the Smart Elderly Healthcare Industry" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="Digital Elderly Care Summit Forum" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="Big Data Application and Security Forum" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="The 12th China Smart City Summit" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="The 7th China Security System Integrators Forum" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="National Security Association Roundtable" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="China (Shenzhen) Road Traffic Safety Forum 2023" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="Tencent Cloud Special Session" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="Arm Smart Vision Innovation Forum" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="Huawei Conference" name="forum"></el-checkbox>
            <br />
            <el-checkbox label='GB 55029-2022 "General Code of Security Engineering" Training and Promotion Meeting' name="forum"></el-checkbox>
            <br />
            <el-checkbox label="APSA EXCO AGM Meeting" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="Digital City and Unmanned System Development Forum" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="The 7th Security Semiconductor Industry Development and Innovation Forum" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="Digital Energy Summit 2023" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="International Security Forum 2023" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="Digital Communities/Parks Summit" name="forum"></el-checkbox>
            <br />
            <el-checkbox :label="'National Security Association Party Building Joint Learning  and Innovation Development  Forum'" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="Digital Countryside Summit 2023" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="The 17th China Security Forum - Global Technology Forum / Overseas Forum" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="The 27th APSA International Security Forum" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="South Asia Southeast Asia International Security Alliance Conference" name="forum"></el-checkbox>
            <br />
            <el-checkbox label="Other:" name="forum"></el-checkbox>
            <br />

              <el-input class="elseinp" v-model="ruleForm.forum_other" placeholder="Please fill in the 'Other' reason description"></el-input>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button class="subbin" type="primary" @click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      ruleForm: {
        name: '',
          Company: '',
        Nationality: '',
             position: '',
                  email: '',
                   phone_number: '',
                    address: '',
                    introduction: '',
                     potential: '',
        c_logo: '',
        forum: [],
        forum_other: '',
      },
      rules: {

 /*       name: this.ruleForm.name,
                company: this.ruleForm.company,
                nationality: this.ruleForm.Nationality,
                position: this.ruleForm.position,
                email: this.ruleForm.email,
                phone_number: this.ruleForm.phone_number,
                address: this.ruleForm.address,
                introduction: this.ruleForm.introduction,
                potential: this.ruleForm.potential,
                c_logo: this.ruleForm.c_logo,

                speech_abstracts: forum+this.ruleForm.forum_other, */
        name: [{required: true, message: 'This question must be filled out', trigger: 'blur' }],
        Company: [{required: true, message: 'This question must be filled out', trigger: 'blur' }],
        Nationality: [{required: true, message: 'This question must be filled out', trigger: 'blur' }],
        position: [{required: true, message: 'This question must be filled out', trigger: 'blur' }],
        email: [{required: true,message: 'This question must be filled out', trigger: 'blur' },
                 {type:'email',message: 'Please enter correct E-mail Address', trigger: 'blur' }],
        phone_number: [{required: true, message: 'This question must be filled out', trigger: 'blur' }
        ],
        address: [{required: true, message: 'This question must be filled out', trigger: 'blur' }],
        potential: [{required: true, message: 'This question must be filled out', trigger: 'blur' }],
        c_logo: [
                                { required: true,message: 'Please upload logo', trigger: ['change','blur']}
                            ],



        forum: [
          {
            type: "array",
            required: true,
            message: "Please select at least one forum",
            trigger: ['change','blur']
          }
        ],
      }
    };
  },
  beforeCreate() {

  },
   created(){

    //记录访问数量
     this.$axios({
      url:
        "https://en.droneworldcongress.com/form/index/yea_attendee/index.html?button_id=" +
         this.$route.query.button_id +
        "&contacts_id=" +
        this.$route.query.contacts_id,
      method: "post",
      data: {}
    })
  },
  methods: {
    // 上传图片获取参数
    logo_success(res) {
      console.log(res);
      this.ruleForm.c_logo = res.url;
    },
    logo_before(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过10M!");
      }
    },
     handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid,object) => {
        if (valid) {

          if(this.ruleForm.c_logo==''){ this.$message.error("Please upload logo!"); return false;}

          let button_id = this.$route.query.button_id;
          let contacts_id = this.$route.query.contacts_id;
          // alert(this.ruleForm.Nationality);
          // let permission = this.ruleForm.companytype.join(",");
          let forum_other=this.ruleForm.forum_other==''?'':','+this.ruleForm.forum_other;
          let forum = this.ruleForm.forum.join(",")+forum_other;
          let url = "https://en.droneworldcongress.com/form/index/yea_attendee/index.html=" +button_id +"&contacts_id=" + contacts_id
          this.$axios({
            url:url,
            method: "post",
            data: {
              name: this.ruleForm.name,
              company: this.ruleForm.Company,
              nationality: this.ruleForm.Nationality,
              position: this.ruleForm.position,
              email: this.ruleForm.email,
              phone_number: this.ruleForm.phone_number,
              address: this.ruleForm.address,
              introduction: this.ruleForm.introduction,
              potential: this.ruleForm.potential,
              c_logo: this.ruleForm.c_logo,

      /*        contact_number: this.ruleForm.Company+this.ruleForm.comtype_other,
              company_focus: permission, */
              speech_abstracts: forum,
              url: url
            }
          })
            .then(res => {
              if(res.status == 0){
                this.$message({
                message: '提交失败',
                type: 'warning'
              });
              }{
                     this.$router.push({name:'succSpeaker'});
              }

            })
            .catch(err => {
              this.$message({
                message: '提交失败',
                type: 'warning'
              });
            });
        }else{
          setTimeout(()=>{
            var isError= document.getElementsByClassName("is-error");
            isError[0].querySelector('input').focus();
          },100);
          return false;

        }
      })
    },
  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.case {
  margin: auto;
  max-width: 90vw;
  width: 640px;
  padding-top: 12px;
}
.hello {
  width: 100%;
  height: 100%;
  background-color: rgb(240, 235, 248);
  background-size: 100% 100%;
}
.top {
  /* margin-top: 12px; */
  background-color: #fff;
  border: 1px solid #dadce0;
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 24px;
  padding-top: 22px;
  position: relative;
  text-align: left;
}
.ti-blck {
  background-color: rgb(103, 58, 183);
  color: rgba(255, 255, 255, 1);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  height: 10px;
  left: -1px;
  position: absolute;
  top: -1px;
  width: calc(100% + 2px);
}
.title {
  font-family: "Google Sans", Roboto, Arial, sans-serif;
  font-size: 32px;
  font-weight: 400;
  line-height: 40px;
  color: #202124;
  line-height: 135%;
  max-width: 100%;
  min-width: 0%;
}
.introduce {
  font-family: Roboto, Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.2px;
  line-height: 20px;
  color: #202124;
  margin-top: 12px;
}
.must {
  font-family: Roboto, Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.2px;
  line-height: 20px;
  margin-top: 12px;
  color: #d93025;
}
.el-checkbox {
  white-space: pre-line !important;
  margin-right: 0px !important;
}
.el-checkbox__label {
  display: initial !important;
}

/* 尾部 */
.tail {
  -webkit-transition: background-color 200ms cubic-bezier(0, 0, 0.2, 1);
  transition: background-color 200ms cubic-bezier(0, 0, 0.2, 1);
  background-color: #fff;
  border: 1px solid #dadce0;
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 24px;
  page-break-inside: avoid;
  word-wrap: break-word;
  text-align: left;
}
.cause {
  font-family: "Google Sans", Roboto, Arial, sans-serif;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.1px;
  line-height: 24px;
  color: #202124;
  font-weight: 400;
  width: 100%;
  word-break: break-word;
}
.form-inp {
  margin-left: 0px !important;
}
.sign {
  color: #d93025;
}
.inpdisp .el-input {
  display: none;
}
/* .elseinp {
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #42b983;
} */
.subbin {
  background-color: rgb(103, 58, 183);
  margin-bottom: 20%;
}
.tick2021{
  color: #b7bfd0;
}


h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Digitalcitycongress.vue